import React from "react";
import { Modal } from "components";
import { EditSectionTemplate } from "components/MainSectionTemplate/EditSectionTemplate";
import { ProductCheckboxList } from "components/ProductCheckboxList";
import OptionalTextAreaInput from "components/ValidatedFields/OptionalTextAreaInput";
import { CompanySmallDetails } from "components/SmallDetails";
import { isNullOrEmptyString } from "shared/utils";
import { routes } from "utilities/routing/generatedRoutes";

interface Props {
  onClose: () => void;
  productsByParent: server.dto.ProductsByParent;
  invoice: server.dto.InvoiceV2;
  createCreditConcerningText: string;
  canModifyPayments: boolean;
}

const MakeCreditModal = (props: Props) => {

  const products = props.productsByParent.collection;
  const hasProducts = products.length > 0;

  const [concerning, setConcerning] = React.useState(() => [props.createCreditConcerningText, props.invoice.concerning]
    .filter(value => !isNullOrEmptyString(value))
    .join("\n\n"));
  const [selectedProducts, setSelectedProducts] = React.useState<number[]>(() => products.map(p => p.productId));

  const submit = () => window.CoreApi.InvoiceV2.MakeCredit({
    invoiceId: props.invoice.invoiceId,
    concerning,
    selectedProductIds: selectedProducts,
  } satisfies Required<server.dto.MakeCreditInvoiceV2Instruction>);

  return (
    <Modal
      isOpen
      title={RESX.Invoice.MakeCredit}
      handleClose={props.onClose}
      width="small"
      hasAutoScrollBox
      minHeight={400}
    >
      <div className="grow1 scrollbox-auto">
        <EditSectionTemplate
          submit={submit}
          redirectUrl={invoiceId => routes.invoiceV2_Detail(invoiceId).absolute}
          noPanels
          sections={[
            {
              key: "makeCreditDetails",
              type: "regular",
              title: RESX.Invoice.MakeCredit,
              fields: [
                {
                  key: "invoiceNumber",
                  label: RESX.Invoice.ForInvoice,
                  renderEditNew: () => (
                    <div className="main-section-template-fields-padding">
                      {props.invoice.documentNumber}
                    </div>
                  )
                },
                {
                  key: "addressee",
                  label: RESX.Document.Addressee,
                  renderEditNew: () => (
                    <div className="main-section-template-fields-padding">
                      <CompanySmallDetails company={props.invoice.company} layout="multiLine" />
                    </div>
                  )
                },
                {
                  key: "concerning",
                  label: RESX.InvoiceDocument.Concerning,
                  renderEditNew: () => (
                    <OptionalTextAreaInput
                      maxLength={serverReference.constants.document.maxConcerningLength}
                      value={concerning}
                      onChange={setConcerning}
                    />
                  )
                }
              ]
            },
            {
              key: "products",
              type: "regular",
              title: RESX.Product.Products,
              hidden: !hasProducts,
              fields: [
                {
                  key: "productList",
                  label: RESX.Product.Products,
                  renderEditNew: () => (
                    <ProductCheckboxList
                      products={products}
                      selectedProducts={selectedProducts}
                      setSelectedProducts={setSelectedProducts}
                    />
                  )
                }
              ]
            }
          ]}
        />
      </div>
    </Modal>
  );
};

export default MakeCreditModal;
